import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5ED659B5-F175-445F-950D-0B4DDAB3F8B3
 * name square-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-outline.svg
 * tags
 * - Shape 
 */
export const SquareOutlineIcon = createSvgIcon(<><path d="M3,3H21V21H3V3M5,5V19H19V5H5Z" /></>, 'SquareOutlineIcon');
export default SquareOutlineIcon